import type { VideoContentObject } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Delete2LineIcon, type MenuProps, PencilLineIcon } from 'ui';
import { useDeleteVideo } from './useDeleteVideo';

export const useActions = ({
  onRequestEdit,
  onVideoDeleted,
  videoContentObject,
}: {
  onRequestEdit: (opened: true) => void;
  onVideoDeleted: () => Promise<void>;
  videoContentObject: VideoContentObject;
}) => {
  const { t } = useTranslation();
  const { confirm: deleteVideo, contextHolder } = useDeleteVideo({ onVideoDeleted, videoContentObject });
  const { canDeleteVideo, canEditVideo } = usePermissions();

  return useMemo(() => {
    const actions: MenuProps['items'] = [];

    if (canEditVideo({ video: videoContentObject })) {
      actions.push({
        icon: <PencilLineIcon />,
        key: 'edit',
        label: t('Edit'),
        onClick() {
          onRequestEdit(true);
        },
      });
    }

    if (canDeleteVideo({ video: videoContentObject })) {
      actions.push({
        danger: true,
        icon: <Delete2LineIcon />,
        key: 'delete',
        label: t('Delete draft'),
        onClick() {
          deleteVideo();
        },
      });
    }

    return {
      actions,
      contextHolder,
    };
  }, [canEditVideo, videoContentObject, canDeleteVideo, contextHolder, t, onRequestEdit, deleteVideo]);
};
